// In-progress workout state, persisted to localStorage so a phone-lock, reload,
// or app-kill mid-workout doesn't lose entered weights/reps. Keyed per user.

import { activeUser } from './auth.js';

const key = (user = activeUser()) => `grit-progress-${user}`;

export function saveProgress(state) {
  try { localStorage.setItem(key(), JSON.stringify(state)); } catch { /* quota / private mode */ }
}

export function loadProgress(user = activeUser()) {
  try { return JSON.parse(localStorage.getItem(key(user)) || 'null'); } catch { return null; }
}

export function clearProgress(user = activeUser()) {
  localStorage.removeItem(key(user));
}

// How many work sets are checked off in a saved progress blob (for the banner).
export function progressCounts(state) {
  let done = 0;
  let total = 0;
  for (const e of state?.cards || []) {
    for (const s of e.card?.sets || []) {
      if (s.isWarmup) continue;
      total += 1;
      if (s.done) done += 1;
    }
  }
  return { done, total };
}
